module.exports = __webpack_public_path__ + "static/img/wx-code.fe965a8d.jpg";